<template>
    <div>
        <Modal :title="type + '配置管理信息'" :value="value" @on-ok="save" :mask-closable="false" @on-cancel="cancel">
            <Form :model="form" :label-width="94" label-position="right" ref="formValidate" :rules="ruleValidate">
                <FormItem label="父级选项：">
                    <Cascader :data="cascaderData" v-model="form.parentSelectItemId" change-on-select />
                </FormItem>

                <FormItem label="选项名称：" prop="name">
                    <Input type="text" placeholder="请输入" v-model="form.name"></Input>
                </FormItem>

                <FormItem label="选项值：" prop="value">
                    <Input type="text" placeholder="请输入" v-model.number="form.value"></Input>
                </FormItem>

                <FormItem label="选项组：" prop="group">
                    <Input type="text" placeholder="请输入" v-model="form.group"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancel">取消</Button>
                <Button @click="save" type="primary">确认</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name: 'create-configure',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
        },
    },
    data() {
        return {
            cascaderData: [],
            form: {
                name: '',
                // mouldType: '',
                // inspectionType: '',
                // projectName: '',
                value: null,
                group: '',
                parentSelectItemId: [],
            },
            fromFields: {},
            mouldFrom: [],
            isIndicator: true,
            mould: false,
            disabled: false,
            ruleValidate: {
                name: [{ required: true, message: '不能为空', trigger: 'change', type: 'string' }],

                // mouldType: [{ required: true, message: '不能为空', trigger: 'blur', type: 'number' }],

                // inspectionType: [{ required: true, message: '不能为空', trigger: 'change', type: 'number' }],

                // projectName: [{ required: true, message: '不能为空', trigger: 'change' }],

                value: [{ required: true, message: '不能为空', trigger: 'change', type: 'number' }],

                group: [{ required: true, message: '不能为空', trigger: 'change' }],
            },
        };
    },
    mounted() {
        this.getParentSelectItemId();
    },
    watch: {
        type() {
            if (this.type == '新增') {
                this.form = {
                    name: '',
                    // mouldType: '',
                    // inspectionType: '',
                    // projectName: '',
                    value: null,
                    group: '',
                    parentSelectItemId: [],
                };
            }
        },
    },
    methods: {
        //获取下拉列表的查询数据
        async getParentSelectItemId() {
            let res = await this.$Ajax.get('/api/services/app/SelectItem/GetSelectItemData');
            // let res = {
            //     data: {
            //         result: [
            //             {
            //                 value: '0',
            //                 label: '北京',
            //                 children: [
            //                     {
            //                         value: '1',
            //                         label: '故宫',
            //                     },
            //                     {
            //                         value: '2',
            //                         label: '天坛',
            //                     },
            //                     {
            //                         value: '3',
            //                         label: '王府井',
            //                     },
            //                 ],
            //             },
            //             {
            //                 value: '4',
            //                 label: '江苏',
            //                 children: [
            //                     {
            //                         value: '5',
            //                         label: '南京',
            //                         children: [
            //                             {
            //                                 value: '6',
            //                                 label: '夫子庙',
            //                             },
            //                         ],
            //                     },
            //                     {
            //                         value: '7',
            //                         label: '苏州',
            //                         children: [
            //                             {
            //                                 value: '8',
            //                                 label: '拙政园',
            //                             },
            //                             {
            //                                 value: '9',
            //                                 label: '狮子林',
            //                             },
            //                         ],
            //                     },
            //                 ],
            //             },
            //         ],
            //     },
            // };
            this.cascaderData = res.data.result;
        },
        //保存
        async save(formValidate) {
            this.$refs['formValidate'].validate(async (valid) => {
                if (valid) {
                    let form = JSON.parse(JSON.stringify(this.form));
                    if (this.form.parentSelectItemId.length > 0) {
                        console.log(this.form.parentSelectItemId[this.form.parentSelectItemId.length - 1])
                        form.parentSelectItemId = this.form.parentSelectItemId[this.form.parentSelectItemId.length - 1];
                    } else {
                        form.parentSelectItemId = null;
                    }
                    console.log(form)
                    let respone = null;
                    if (this.type == '新增') {
                        respone = await this.$Ajax.post('/api/services/app/SelectItem/Create', form);
                        this.$Message.success('操作成功!');
                    } else {
                        respone = await this.$Ajax.put('/api/services/app/SelectItem/Update', form);
                        this.$Message.success('操作成功!');
                    }
                    this.cancels();
                }
            });
        },

        //清空表单数据
        handTable(name) {
            this.$refs[name].resetFields();
            this.form = {
                name: '',
                // mouldType: '',
                // inspectionType: '',
                // projectName: '',
                value: null,
                parentSelectItemId: [],
                group: '',
            };
        },
        //关闭子组件时
        cancel() {
            this.$emit('close', false);
            this.handTable('formValidate');
        },
        //关闭弹出框
        cancels() {
            this.$emit('close', { cancel: true });
            this.handTable('formValidate');
        },
        //根据ID获取详细信息
        async getInforID(id, type) {
            console.log(id, type);
            if (type == '编辑') {
                let { data: respose } = await this.$Ajax.get('/api/services/app/SelectItem/Get', { params: { id: id } });
                if (respose.result.mouldType) {
                    this.mould = true;
                }
                console.log('respose',respose);
                this.form = {
                    name: respose.result.name,
                    // mouldType: respose.result.mouldType,
                    // inspectionType: respose.result.inspectionType,
                    // projectName: respose.result.projectName,
                    value: respose.result.value,
                    group: respose.result.group,
                    parentSelectItemId: respose.result.parentSelectItems,
                    id: respose.result.id,
                };
                console.log('respose1',respose);
                // this.form.parentSelectItemId.push(...respose.result.parentSelectItems);
            }
        },
    },
};
</script>

<style lang="less" scoped="scoped">
/deep/ .ivu-select-disabled .ivu-select-selection {
    background-color: #ffffff !important;
    opacity: 1;
    cursor: not-allowed;
    color: rgb(53, 53, 53) !important;
}
</style>
